


























import Vue from "vue";
import i18n from "@/locales/i18n";
import _ from "lodash";

export default Vue.extend({
    name: "EnumPicker",
    props: {
        rightIcon: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        value: {
            type: String
        },
        i18nPrefix: {
            type: String
        },
        placeholder: {
            type: String,
            default: i18n.t("common.placeholder.select")
        },
        rules: Array,
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showPicker: false,
            selectedValue: this.value,
            defaultIndex: _.findIndex(this.options, this.value)
        };
    },
    methods: {
        openModel() {
            if (this.readOnly) {
                return;
            }
            this.showPicker = true;
        },
        optionText(option) {
            if (_.isEmpty(option)) {
                return "";
            }
            return this.i18nPrefix
                ? (this.$t(`${this.i18nPrefix}.${option}`) as string)
                : (this.$t(`${option}`) as string);
        },
        onConfirm(val, index) {
            this.showPicker = false;
            this.selectedValue = this.options[index] as string;
            this.$emit("input", this.selectedValue);
            this.$emit("blur", this.selectedValue);
            this.$emit("change", this.selectedValue);
        }
    },
    computed: {
        columns(): any {
            return _.map(this.options, option => {
                return { code: option, text: this.optionText(option) };
            });
        },
        selectedText(): string {
            return this.optionText(this.selectedValue);
        }
    },
    watch: {
        value(newVal) {
            this.selectedValue = newVal;
            this.defaultIndex = _.findIndex(this.options, this.selectedValue);
        }
    }
});
